import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { PASTE_COMMAND, COMMAND_PRIORITY_LOW } from 'lexical';
type PastePluginProps = {
  shouldBlockPaste?: boolean;
};
const PastePlugin = ({
  shouldBlockPaste = false
}: PastePluginProps) => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    return editor.registerCommand(PASTE_COMMAND, (event: ClipboardEvent) => {
      if (shouldBlockPaste) {
        event.preventDefault();
        alert('Pasting is disabled!');
        return true; // Indicate that we handled the paste event
      }
      return false; // Let Lexical handle the paste event
    }, COMMAND_PRIORITY_LOW);
  }, [editor, shouldBlockPaste]);
  return null;
};
export default PastePlugin;